import React, { useMemo, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import districtCatalog from '../../catalogs/distritos_cat008.json';

/**
 * Selector de distrito del catálogo CAT-008 de MH.
 * Catálogo generado desde CAT-008 en formato JSON válido.
 */
const DistrictSelect = ({
  value,
  onChange,
  label = 'Distrito',
  required = false,
  error = '',
  disabled = false,
  size = 'medium',
}) => {
  const [open, setOpen] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState(null);

  const districts = useMemo(() => districtCatalog.map((district, index) => ({
    ...district,
    // Los códigos se repiten en distintos municipios; la clave solo es
    // necesaria para renderizar opciones distintas en el listado.
    id: `${district.code}-${index}`,
  })), []);

  const currentValue = useMemo(() => {
    if (!value) return null;
    if (typeof value === 'object' && value !== null) return value;
    if (selectedDistrict?.code === String(value)) return selectedDistrict;
    return districts.find((district) => district.code === String(value)) || null;
  }, [value, districts, selectedDistrict]);

  const filterOptions = (options, state) => {
    const inputValue = state.inputValue.toLowerCase();
    return options.filter((option) => (
      option.code.includes(inputValue) || option.name.toLowerCase().includes(inputValue)
    ));
  };

  return (
    <Autocomplete
      fullWidth
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={districts}
      value={currentValue}
      disabled={disabled}
      onChange={(_, newValue) => {
        setSelectedDistrict(newValue);
        onChange(newValue ? newValue.code : '');
      }}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option ? `${option.code} - ${option.name}` : ''}
      isOptionEqualToValue={(option, selected) => (
        option.id === selected?.id || (!selected?.id && option.code === (selected?.code || selected))
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          required={required}
          error={!!error}
          helperText={error || 'Código de distrito según catálogo MH'}
        />
      )}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <li key={key || option.id} {...rest}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 600 }}>{option.code}</span>
              <span style={{ fontSize: '0.85em', color: '#666' }}>{option.name}</span>
            </div>
          </li>
        );
      }}
      noOptionsText="No se encontraron distritos"
      placeholder="Seleccione un distrito"
    />
  );
};

export default DistrictSelect;
